import { inject, Pipe, PipeTransform } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core/lib/models/fieldconfig';
import { FormlySelectOptionsPipe } from '@ngx-formly/core/select';
import { map, Observable } from 'rxjs';
import { LuRadioSelectOption } from './lu-radio.model';

@Pipe({
	name: 'luRadioOptions'
})
export class LuRadioOptionsPipe implements PipeTransform {
	formlySelectOptionsPipe = inject(FormlySelectOptionsPipe);

	transform(options: unknown, field: FormlyFieldConfig): Observable<LuRadioSelectOption[]> {
		const formlySelectOptions$ = this.formlySelectOptionsPipe.transform(options, field);
		return formlySelectOptions$.pipe(
			map(formlyOptions => {
				const luRadioSelectOptions = formlyOptions.map((item, index) => ({
					...item,
					value: item.value,
					...(options[index]?.description && { description: options[index].description }),
					...(options[index]?.icon && { icon: options[index].icon }),
					...(options[index]?.additionalFields && { additionalFields: options[index].additionalFields })
				}));
				return luRadioSelectOptions;
			})
		);
	}
}
